// extracted by mini-css-extract-plugin
export default {"typeContainer":"Other_typeContainer__TU3qa","chechBoxItem":"Other_chechBoxItem__K8RbS","chechBox":"Other_chechBox__tftou"};